import styled from 'styled-components';
import { Grid } from '@material-ui/core';

// CONSTANTS
import { SANTAS_GRAY, MAIN_BLACK, WHITE, PURPLE } from '@/constants/colors';
import { breakpoints } from '@/utility/breakpoints';

export const Content = styled.div`
  padding-top: 30px;

  ${breakpoints.down('sm')} {
    padding-top: 50px;
  }
`;

export const AboutContent = styled(Content)`
  font-size: 1.6rem;

  p {
    margin-bottom: 24px;

    &:first-of-type {
      padding-top: 0;
    }

    &:last-of-type {
      padding-bottom: 0;
    }
  }

  blockquote {
    font-size: 1.9rem;
    font-weight: 500;
    font-style: italic;
    margin: 0 0 20px;
  }

  h5 {
    line-height: 3rem;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  ul {
    margin: 0 0 15px;
    padding-inline-start: 30px;
  }

  b {
    font-weight: 500;
  }

  a {
    color: ${PURPLE};
  }

  ${breakpoints.down('sm')} {
    padding-top: 20px;

    p {
      font-size: 1.6rem;
      line-height: 2.6rem;
    }
  }
`;

export const DevicesContent = styled(Content)`
  padding-top: 50px;
`;

export const GenderContent = styled(Content)`
  padding-top: 50px;
`;

export const DevicesGrid = styled(Grid)`
  margin-top: 30px;

  > .MuiGrid-item {
    display: flex;
    align-items: center;
  }

  img {
    max-height: 50px;
  }

  ${breakpoints.down('md')} {
    width: calc(100% + 16px);
    margin: -8px;
    margin-top: 22px;

    > .MuiGrid-item {
      display: flex;
      align-items: center;
      padding: 8px;
    }
  }
`;

export const GenresGrid = styled(Grid)`
  margin-top: 12px;
`;

export const ListWrapper = styled.div`
  padding: 35px 0 40px;

  ${breakpoints.down('sm')} {
    padding: 30px 0 0;

    &:first-of-type {
      padding: 18px 0 0;
    }
  }
`;

export const RatingListWrapper = styled(ListWrapper)`
  padding-bottom: 0;
`;

export const RatingsList = styled.ul`
  list-style: none;
  padding-left: 0;
  margin: 0;

  li {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    line-height: 1.8rem;

    margin-bottom: 22px;

    &:last-of-type {
      margin-bottom: 0;
    }

    div {
      display: flex;
    }

    .service {
      flex-wrap: wrap;
      margin-right: 8px;

      .count {
        margin-left: 5px;
        color: ${SANTAS_GRAY};
      }
    }
  }
`;

export const CordCut = styled.div`
  padding: 25px 20px;

  .cord-cut,
  &.cord-cut {
    border-radius: 6px;
    background-color: ${MAIN_BLACK};
    position: relative;
    overflow: hidden;
    color: ${WHITE};

    &__content {
      position: relative;
      z-index: 1;
    }

    &__triangle {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 0 91px 182px;
      border-color: transparent transparent ${p => p.theme.palette.primary.main} transparent;
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 0;
    }

    &__title {
      margin-bottom: 10px;
      line-height: 2.4rem;
    }

    &__btn {
      i {
        font-size: 1.2rem;
      }
    }
  }
`;

export default Content;
